import { useState } from 'react';
import superagent from '@ott/superagent';

const MIN_INTERACTION_TIME_MS = 500;

const delay = (time: number) => {
  // eslint-disable-next-line no-promise-executor-return
  return new Promise((resolve) => setTimeout(resolve, time));
};

const trackError = (error: any) => {
  // @ts-ignore
  global.trackJs?.track('@ott/activities-like', error);
  console.error('@ott/activities-like', error);
};

export type SuccessfulLikeSetResult = {
  activityId: number;
  isLiked: boolean;
};

type SetActivityLikedTo = (
  activityId: number,
  expectedIsLiked: boolean
) => Promise<SuccessfulLikeSetResult | null>;

type Result = {
  expectedIsLiked: boolean | null;
  isLoading: boolean;
  setActivityLikedTo: SetActivityLikedTo;
};

const useLike = (): Result => {
  const [expectedIsLiked, setExpectedIsLiked] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const setActivityLikedTo: SetActivityLikedTo = async (activityId, expectedIsLikedValue) => {
    setIsLoading(true);
    setExpectedIsLiked(expectedIsLikedValue);

    const startTime = Date.now();
    const resetWithDelay = async () => {
      await delay(Math.max(0, MIN_INTERACTION_TIME_MS - (Date.now() - startTime)));

      setIsLoading(false);
      setExpectedIsLiked(null);
    };

    try {
      const request = expectedIsLikedValue ? superagent.post : superagent.del;
      await request(`/_activities/v3/favorites/${activityId}`);

      await resetWithDelay();

      return {
        activityId,
        isLiked: expectedIsLikedValue,
      };
    } catch (error: any) {
      trackError(error);

      await resetWithDelay();

      return null;
    }
  };

  return {
    expectedIsLiked,
    isLoading,
    setActivityLikedTo,
  };
};

export default useLike;
